(() => {
  if (window.__pfvLoaded) return;
  window.__pfvLoaded = true;

  const waitForEmbla = (callback, tries = 0) => {
    if (typeof EmblaCarousel !== 'undefined') return callback();
    if (tries >= 50) {
      console.warn('[ProductFeaturesVariant] Embla carousel library not found after retries');
      return;
    }
    setTimeout(() => waitForEmbla(callback, tries + 1), 100);
  };

  // Builds the synced text + media carousels for one feature set (same behaviour as product-features-javascript.js).
  function initSet(set) {
    if (set._pfv) {
      set._pfv.media.reInit();
      set._pfv.content.reInit();
      set._pfv.media.scrollTo(0, true);
      set._pfv.content.scrollTo(0, true);
      return;
    }

    const contentRoot = set.querySelector('[data-pfv-content]');
    const mediaRoot = set.querySelector('[data-pfv-media]');
    const contentViewport = contentRoot?.querySelector('.embla__viewport');
    const mediaViewport = mediaRoot?.querySelector('.embla__viewport');
    if (!contentViewport || !mediaViewport) return;

    try {
      const options = { loop: false, dragFree: false, containScroll: 'trimSnaps' };
      const media = EmblaCarousel(mediaViewport, options);
      const content = EmblaCarousel(contentViewport, options);
      set._pfv = { media, content };

      let isSyncing = false;
      const sync = (from, to) => () => {
        if (isSyncing) return;
        isSyncing = true;
        const index = from.selectedScrollSnap();
        if (to.selectedScrollSnap() !== index) to.scrollTo(index);
        isSyncing = false;
      };
      media.on('select', sync(media, content));
      content.on('select', sync(content, media));

      const prev = contentRoot.querySelector('.embla__prev');
      const next = contentRoot.querySelector('.embla__next');
      prev?.addEventListener('click', () => content.scrollPrev());
      next?.addEventListener('click', () => content.scrollNext());

      const dots = contentRoot.querySelectorAll('.embla__dot');
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          media.scrollTo(index);
          content.scrollTo(index);
        });
      });

      const update = () => {
        if (prev) prev.disabled = !content.canScrollPrev();
        if (next) next.disabled = !content.canScrollNext();
        const selected = content.selectedScrollSnap();
        dots.forEach((dot, index) => {
          const isActive = index === selected;
          dot.classList.toggle('bg-black', isActive);
          dot.classList.toggle('bg-[#7E7E7E40]', !isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };
      content.on('select', update);
      media.on('select', update);
      content.on('reInit', update);
      update();
    } catch (error) {
      console.error('[ProductFeaturesVariant] Error initializing carousel:', error);
    }
  }

  function showSet(root, key) {
    const sets = root.querySelectorAll('[data-pfv-set]');
    const target =
      Array.from(sets).find((set) => set.dataset.pfvSet === key) ||
      Array.from(sets).find((set) => set.dataset.pfvSet === 'product');
    if (!target) return;
    if (root.dataset.pfvActive === target.dataset.pfvSet && target._pfv) return;

    sets.forEach((set) => {
      set.hidden = set !== target;
    });
    root.dataset.pfvActive = target.dataset.pfvSet;
    initSet(target);
  }

  function initRoot(root) {
    const active = root.querySelector(`[data-pfv-set="${root.dataset.pfvActive}"]`);
    if (active) initSet(active);
  }

  waitForEmbla(() => {
    document.querySelectorAll('[data-pfv-root]').forEach(initRoot);

    document.addEventListener('variant:changed', (event) => {
      const id = event.detail?.variantId ?? event.detail?.variant?.id;
      if (id == null) return;
      document.querySelectorAll('[data-pfv-root]').forEach((root) => showSet(root, String(id)));
    });

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-pfv-root]').forEach(initRoot);
    });
  });
})();
